import { message } from "antd";
import type { RequestError } from "./request";

interface BackendErrorShape {
  error?: string | Record<string, unknown>;
  message?: string;
}

export function extractErrorMessage(error: unknown): string {
  if (typeof error !== "object" || error === null) {
    return "Something went wrong. Please try again.";
  }

  const err = error as RequestError;
  const data = err.data as BackendErrorShape | undefined;

  if (data?.error && typeof data.error === "string") {
    return data.error;
  }

  if (data?.error && typeof data.error === "object") {
    const json = (data.error as { json?: Record<string, string[]> }).json;
    if (json) {
      const firstField = Object.keys(json)[0];
      const firstMsg = json[firstField]?.[0];
      if (firstMsg) return firstMsg;
    }
  }

  if (data?.message) return data.message;
  if (err.message) return err.message;
  return "Something went wrong. Please try again.";
}

export function handleAxiosError(error: unknown): void {
  message.error(extractErrorMessage(error));
}
